import { render, staticRenderFns } from "./ColorsSetting.vue?vue&type=template&id=2681fc1f&"
import script from "./ColorsSetting.vue?vue&type=script&lang=js&"
export * from "./ColorsSetting.vue?vue&type=script&lang=js&"
import style0 from "./ColorsSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports